module.exports = __webpack_public_path__ + "img/swagger.6566a74d.jpg";